import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.question_flow.title',
        defaultMessage: 'Set up questions',
    },
    question: {
        id: 'modal.3ds.question_flow.question',
        defaultMessage: 'Question',
    },
    questionOf: {
        id: 'modal.3ds.question_flow.question_of',
        defaultMessage: 'Question {question} of {qLen}',
    },
    your: {
        id: 'modal.3ds.question_flow.tour_answer',
        defaultMessage: 'Your answer (Case sensitive)',
    },
    cancel: {
        id: 'modal.3ds.question_flow.cancel',
        defaultMessage: 'Cancel',
    },
    submit: {
        id: 'modal.3ds.question_flow.submit',
        defaultMessage: 'Submit',
    },
    nextQ: {
        id: 'modal.3ds.question_flow.next_q',
        defaultMessage: 'Next question',
    },
})
